import $ from "jquery";

export const init = function () {
  let timeOutFunctionId;

  $(".flyout-row").each(function (e) {
    $(this).addClass("cols-" + $(this).find(".flyout-col").length);
  });

  $(".boilerplate").last().parents(".flyout-section").addClass("last");
  $(".header-top-row .topmenu")
    .clone()
    .prependTo(".flyout-section.last > .container");

  $("#flyout-menu-rebrush").on("click", function (e) {
    var $fNavBtn = $("#flyout-menu-rebrush");
    var $fNav = $(".big-nav");
    if ($fNavBtn.hasClass("open")) {
      $fNavBtn.removeClass("open");
      $fNav.slideUp();
    } else {
      $fNavBtn.addClass("open");
      $fNav.slideDown();
    }
  });

  $(window).on("resize", function (e) {
    clearTimeout(timeOutFunctionId);
    timeOutFunctionId = setTimeout(function () {
      if ($(window).width() > 992) {
        $(".big-nav").attr("style", "");
      }
    }, 100);
  });

  $(".flyout-navigation .navbar-nav .flyout-links .header").on(
    "click",
    function (e) {
      var $fLinks = $(e.target).parents(".flyout-links");
      if ($fLinks.hasClass("open")) {
        $fLinks.removeClass("open");
        $fLinks.find("ul").slideUp();
      } else {
        $(".flyout-links.open").find("ul").slideUp();
        $(".flyout-links.open").removeClass("open");
        $fLinks.addClass("open");
        $fLinks.find("ul").slideDown();
      }
    }
  );

  $(".flyout-container a").attr("tabindex", "-1");

  let showBigMenu = ($this) => {
    $(".nav-link").removeClass("show");
    $(".nav-item .flyout-container a").attr("tabindex", "-1");
    $this.addClass("show");
    $this
      .parents(".nav-item")
      .find(".flyout-container a")
      .attr("tabindex", "0");
  };

  let hideBigMenu = ($this) => {
    $(".nav-link").removeClass("show");
    $this
      .parents(".nav-item")
      .find(".flyout-container a")
      .attr("tabindex", "-1");
  };

  // $(".nav-link").on("click", function (e) {
  //   e.preventDefault();
  //   let $this = $(this);
  //   $this.hasClass("show") ? hideBigMenu($this) : showBigMenu($this);
  // });

  $(".big-nav .nav-link").on("mouseenter", function (e) {
    let $this = $(e.target);
    showBigMenu($this);
  });

  $(".big-nav .nav-link").on("mouseleave", function (e) {
    let $this = $(e.target);
    hideBigMenu($this);
  });
};
